import { PLAYER_COLLISION_RADIUS } from './constants.js';
/**
 * Begehbarkeits-Raster der Map. Wird identisch auf Client (sofortige lokale
 * Bewegung) und Server (autoritative Validierung) verwendet — dadurch weichen
 * beide Seiten praktisch nie voneinander ab.
 */
export class CollisionGrid {
    width;
    height;
    blocked;
    constructor(width, height, blocked) {
        this.width = width;
        this.height = height;
        this.blocked = blocked;
    }
    static fromMapData(map) {
        const blocked = new Uint8Array(map.width * map.height);
        for (let y = 0; y < map.height; y += 1) {
            const row = map.collision[y] ?? '';
            for (let x = 0; x < map.width; x += 1) {
                blocked[y * map.width + x] = row[x] === '1' ? 1 : 0;
            }
        }
        return new CollisionGrid(map.width, map.height, blocked);
    }
    /** Ausserhalb der Map gilt immer als blockiert. */
    isBlocked(tileX, tileY) {
        if (tileX < 0 || tileY < 0 || tileX >= this.width || tileY >= this.height)
            return true;
        return this.blocked[tileY * this.width + tileX] === 1;
    }
    /**
     * Prueft, ob ein Avatar-Kreis (Mittelpunkt x/y in Tile-Koordinaten) frei steht.
     * Es genuegt, die vier Eckpunkte des umschliessenden Quadrats zu testen,
     * da der Radius < 0.5 Tiles ist.
     */
    isWalkable(x, y, radius = PLAYER_COLLISION_RADIUS) {
        const corners = [
            [x - radius, y - radius],
            [x + radius, y - radius],
            [x - radius, y + radius],
            [x + radius, y + radius],
        ];
        return corners.every(([cx, cy]) => !this.isBlocked(Math.floor(cx), Math.floor(cy)));
    }
    /**
     * Bewegt einen Punkt um (dx, dy) mit Achsen-getrenntem "Wall-Slide":
     * Erst X, dann Y — blockierte Achsen werden einzeln verworfen, sodass
     * man an Waenden entlanggleiten kann statt haengenzubleiben.
     */
    moveWithSlide(x, y, dx, dy, radius = PLAYER_COLLISION_RADIUS) {
        let nextX = x;
        if (dx !== 0 && this.isWalkable(x + dx, y, radius))
            nextX = x + dx;
        let nextY = y;
        if (dy !== 0 && this.isWalkable(nextX, y + dy, radius))
            nextY = y + dy;
        return { x: nextX, y: nextY };
    }
}
//# sourceMappingURL=collision.js.map